import { createContext, useContext, useState, useEffect } from 'react';
import { loginToApi } from '../api/licenseService';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [email, setEmail] = useState(localStorage.getItem('email') || '');
    const [password, setPassword] = useState(localStorage.getItem('password') || '');
    const [dealerToken, setDealerToken] = useState(() => localStorage.getItem('token') || '');

    useEffect(() => {
        if (dealerToken) {
            localStorage.setItem('token', dealerToken);
        }
    }, [dealerToken]);

  const login = async (email, password) => {
      setEmail(email);
      setPassword(password);
      localStorage.setItem('email', email);

      const token = await loginToApi(email, password);

      setDealerToken(token);
  };

  const logout = () => {
      setEmail('');
      setPassword('');
      localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ email, password, dealerToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}